"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function padString(string, num, pad) {
    var newString = "" + string;
    var numPad = num - newString.length;
    if (numPad > 0) {
        for (var i = 0; i < numPad; i++) {
            newString += pad;
        }
    }
    return newString;
}
exports.padString = padString;
function generateHeaders(req) {
    if (!req || !req.headers)
        return null;
    var headers = {};
    if (req.headers.cookie) {
        headers.cookie = req.headers.cookie;
    }
    if (req.headers['x-forwarded-for']) {
        headers['x-forwarded-for'] = req.headers['x-forwarded-for'];
    }
    if (req.headers['x-epic-correlation-id']) {
        headers['x-epic-correlation-id'] = req.headers['x-epic-correlation-id'];
    }
    return headers;
}
exports.generateHeaders = generateHeaders;
function generateParams(req) {
    if (!req || !req.params)
        return null;
    return req.params;
}
exports.generateParams = generateParams;
function defaultOptions(req) {
    var options = {};
    var headers = generateHeaders(req);
    if (headers) {
        options.headers = headers;
    }
    var params = generateParams(req);
    if (params) {
        options.params = params;
    }
    return options;
}
exports.defaultOptions = defaultOptions;
var defaultNewsBlogRegex = /(news|blog|feed|developer-interviews|tech-blog)\/(.*)/;
function groupUrls(url, locale, groupingRegex) {
    if (!locale || !url)
        return url;
    var groupedUrl = url.replace("/" + locale, '/*');
    groupedUrl = groupedUrl.replace(/%5C%22.*%5C%22/, '');
    var regexToUse = groupingRegex || defaultNewsBlogRegex;
    var regexResult = regexToUse.exec(groupedUrl);
    if (regexResult && regexResult.length > 2) {
        groupedUrl = groupedUrl.replace(regexResult[2], '*');
    }
    return groupedUrl;
}
exports.groupUrls = groupUrls;
//# sourceMappingURL=data:application/json;base64,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